import { MDSDropdown } from '@marqvision/mds-v2';
import { useTestPurchaseProgressOptions } from './@hooks';
import { FILTER_LABEL } from './DynamicFilter/@constants';

export const TestPurchaseProgressFilter = () => {
  const testPurchaseProgress = useTestPurchaseProgressOptions();

  return (
    <MDSDropdown
      label={FILTER_LABEL['Test Purchase progress']}
      value={testPurchaseProgress.selected}
      list={testPurchaseProgress.list}
      isDisabled={testPurchaseProgress.disabled}
      isLoading={testPurchaseProgress.isFetching}
      onChange={(value) => testPurchaseProgress.select(value)}
      modules={['search']}
    />
  );
};
